import { render, staticRenderFns } from "./DormSearch.vue?vue&type=template&id=c39e85fe&scoped=true&"
import script from "./DormSearch.vue?vue&type=script&lang=js&"
export * from "./DormSearch.vue?vue&type=script&lang=js&"
import style0 from "./DormSearch.vue?vue&type=style&index=0&id=c39e85fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39e85fe",
  null
  
)

component.options.__file = "DormSearch.vue"
export default component.exports